// extracted by mini-css-extract-plugin
export default {"baner":"style_baner__1bzMT"};